import React, {useEffect, useState} from 'react';
import ResizableBox from "../../utils/ResizableBox";
import {Line} from "react-chartjs-2";
import axios from "axios";
import {BASE_NAME} from "../../../../../services/utils/ApiUrls";
import moment from "moment";
import {getConfig} from "../../../../../services/utils/ConfigUtils";
import {BaseStyle} from "../../../../../styles/shared/BaseStyle";
import {Backdrop, Card, CardContent, CardHeader, CircularProgress, Typography} from "@mui/material";
import clsx from "clsx";

const options = {
	responsive: true,
	plugins: {
		legend: {
			position: 'top',
		},
		title: {
			display: true,
			text: 'Numero di tamponi per giorno',
		},
	},
};

export const AndamentoPositivi = () => {
	const classes = BaseStyle();
	const [dataGrafico, setDataGrafico] = useState(new Date());
	const [loading, setLoading] = useState(false);
	const [data, setData] = useState({
		labels: ['01/12/2021'],
		datasets: [
			{
				label: 'Mokup',
				data: [0],
				backgroundColor: 'rgba(255, 99, 132, 0.5)',
				borderColor: 'rgb(255,17,69)',
				fill: true,
			},
		],
	})
	
	useEffect(() => {
		setDataGrafico(new Date())
	}, [])
	
	useEffect(() => {
		setLoading(true);
		axios
			.get(BASE_NAME + "gestionePazienti/tamponi/getStatsByDayAndEsito/" + moment(dataGrafico).format("DD-MM-YYYY"), getConfig())
			.then((response) => {
				let newData1 = {
					labels: response.data.map(item => moment(new Date(item.label)).format("DD/MM/YYYY")),
					datasets: [
						{
							label: 'POSITIVO',
							data: response.data.map(elem => elem.data["POSITIVO"]),
							backgroundColor: 'rgba(255,0,0,0.5)',
							borderColor: 'rgba(255,0,0,0.5)',
							pointRadius: 4,
							pointHoverRadius: 10,
							stack: 'Stack 0',
							tension: 0.5
						},
						{
							label: 'NEGATIVO',
							data: response.data.map(elem => elem.data["NEGATIVO"]),
							backgroundColor: 'rgba(0,157,255,0.5)',
							borderColor: 'rgba(0,157,255,0.5)',
							pointRadius: 4,
							pointHoverRadius: 10,
							stack: 'Stack 1',
							tension: 0.5
						},
						{
							label: 'NON PERVENUTO',
							data: response.data.map(elem => elem.data["NON PERVENUTO"]),
							backgroundColor: 'rgba(255,145,0,0.5)',
							borderColor: 'rgba(255,145,0,0.5)',
							pointRadius: 4,
							pointHoverRadius: 10,
							stack: 'Stack 2',
							tension: 0.5
						},
						{
							label: 'INDETERMINATO',
							data: response.data.map(elem => elem.data["INDETERMINATO"]),
							backgroundColor: 'rgba(72,255,0,0.5)',
							borderColor: 'rgba(72,255,0,0.5)',
							pointRadius: 4,
							pointHoverRadius: 10,
							stack: 'Stack 3',
							tension: 0.5
						},
						{
							label: 'DUBBIO',
							data: response.data.map(elem => elem.data["DUBBIO"]),
							backgroundColor: 'rgba(152,106,42,0.5)',
							borderColor: 'rgba(152,106,42,0.5)',
							pointRadius: 4,
							pointHoverRadius: 10,
							stack: 'Stack 4',
							tension: 0.5
						},
					]
				}
				
				setData(newData1);
				setLoading(false)
				console.log(response.data)
			})
			.catch((error) => {
				setLoading(false);
				console.log(JSON.stringify(error))
			})
	}, [dataGrafico])
	
	return (
		<React.Fragment>
			<Backdrop open={loading} className={classes.backdrop}>
				<CircularProgress/>
			</Backdrop>
			
			<Card className={clsx(classes.roundBorder)}
			      style={{height: "100%", display: "flex", flexDirection: "column"}}>
				<CardHeader
					title={<Typography variant={"h6"}><b>Tamponi raggruppati per giorno (data esito)</b></Typography>}
					subheader={"Numero di tamponi (asse y) per giorno (asse x), suddivisi per tipo (colore)"}
				/>
				<CardContent style={{flexGrow: 1, overflow: "scroll"}}>
					
					<ResizableBox width={1200} height={600}>
						<Line options={options} data={data} type={"bar"}/>
					</ResizableBox>
				
				</CardContent>
			</Card>
		</React.Fragment>
	);
};
